function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { Ease } from './Controller.js';
import { delimiter, numberAndUnit, isPathLetter } from '../modules/core/regex.js';
import { extend } from '../utils/adopter.js';
import Color from '../types/Color.js';
import PathArray from '../types/PathArray.js';
import SVGArray from '../types/SVGArray.js';
import SVGNumber from '../types/SVGNumber.js';
var getClassForType = function(value) {
    var type = typeof value === "undefined" ? "undefined" : _type_of(value);
    if (type === 'number') {
        return SVGNumber;
    } else if (type === 'string') {
        if (Color.isColor(value)) {
            return Color;
        } else if (delimiter.test(value)) {
            return isPathLetter.test(value) ? PathArray : SVGArray;
        } else if (numberAndUnit.test(value)) {
            return SVGNumber;
        } else {
            return NonMorphable;
        }
    } else if (morphableTypes.indexOf(value.constructor) > -1) {
        return value.constructor;
    } else if (Array.isArray(value)) {
        return SVGArray;
    } else if (type === 'object') {
        return ObjectBag;
    } else {
        return NonMorphable;
    }
};
var Morphable = /*#__PURE__*/ function() {
    "use strict";
    function Morphable(stepper) {
        _class_call_check(this, Morphable);
        this._stepper = stepper || new Ease('-');
        this._from = null;
        this._to = null;
        this._type = null;
        this._context = null;
        this._morphObj = null;
    }
    _create_class(Morphable, [
        {
            key: "at",
            value: function at(pos) {
                return this._morphObj.morph(this._from, this._to, pos, this._stepper, this._context);
            }
        },
        {
            key: "done",
            value: function done() {
                var complete = this._context.map(this._stepper.done).reduce(function(last, curr) {
                    return last && curr;
                }, true);
                return complete;
            }
        },
        {
            key: "from",
            value: function from(val) {
                if (val == null) {
                    return this._from;
                }
                this._from = this._set(val);
                return this;
            }
        },
        {
            key: "stepper",
            value: function stepper(stepper) {
                if (stepper == null) return this._stepper;
                this._stepper = stepper;
                return this;
            }
        },
        {
            key: "to",
            value: function to(val) {
                if (val == null) {
                    return this._to;
                }
                this._to = this._set(val);
                return this;
            }
        },
        {
            key: "type",
            value: function type(type) {
                // getter
                if (type == null) {
                    return this._type;
                }
                // setter
                this._type = type;
                return this;
            }
        },
        {
            key: "_set",
            value: function _set(value) {
                if (!this._type) {
                    this.type(getClassForType(value));
                }
                var result = new this._type(value);
                if (this._type === Color) {
                    result = this._to ? result[this._to[4]]() : this._from ? result[this._from[4]]() : result;
                }
                if (this._type === ObjectBag) {
                    result = this._to ? result.align(this._to) : this._from ? result.align(this._from) : result;
                }
                result = result.toConsumable();
                this._morphObj = this._morphObj || new this._type();
                this._context = this._context || Array.apply(null, Array(result.length)).map(Object).map(function(o) {
                    o.done = true;
                    return o;
                });
                return result;
            }
        }
    ]);
    return Morphable;
}();
export { Morphable as default };
export var NonMorphable = /*#__PURE__*/ function() {
    "use strict";
    function NonMorphable() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        _class_call_check(this, NonMorphable);
        this.init.apply(this, _to_consumable_array(args));
    }
    _create_class(NonMorphable, [
        {
            key: "init",
            value: function init(val) {
                val = Array.isArray(val) ? val[0] : val;
                this.value = val;
                return this;
            }
        },
        {
            key: "toArray",
            value: function toArray() {
                return [
                    this.value
                ];
            }
        },
        {
            key: "valueOf",
            value: function valueOf() {
                return this.value;
            }
        }
    ]);
    return NonMorphable;
}();
export var TransformBag = /*#__PURE__*/ function() {
    "use strict";
    function TransformBag() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        _class_call_check(this, TransformBag);
        this.init.apply(this, _to_consumable_array(args));
    }
    _create_class(TransformBag, [
        {
            key: "init",
            value: function init(obj) {
                if (Array.isArray(obj)) {
                    obj = {
                        scaleX: obj[0],
                        scaleY: obj[1],
                        shear: obj[2],
                        rotate: obj[3],
                        translateX: obj[4],
                        translateY: obj[5],
                        originX: obj[6],
                        originY: obj[7]
                    };
                }
                Object.assign(this, TransformBag.defaults, obj);
                return this;
            }
        },
        {
            key: "toArray",
            value: function toArray() {
                var v = this;
                return [
                    v.scaleX,
                    v.scaleY,
                    v.shear,
                    v.rotate,
                    v.translateX,
                    v.translateY,
                    v.originX,
                    v.originY
                ];
            }
        }
    ]);
    return TransformBag;
}();
TransformBag.defaults = {
    scaleX: 1,
    scaleY: 1,
    shear: 0,
    rotate: 0,
    translateX: 0,
    translateY: 0,
    originX: 0,
    originY: 0
};
var sortByKey = function(a, b) {
    return a[0] < b[0] ? -1 : a[0] > b[0] ? 1 : 0;
};
export var ObjectBag = /*#__PURE__*/ function() {
    "use strict";
    function ObjectBag() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        _class_call_check(this, ObjectBag);
        this.init.apply(this, _to_consumable_array(args));
    }
    _create_class(ObjectBag, [
        {
            key: "align",
            value: function align(other) {
                var values = this.values;
                for(var i = 0, il = values.length; i < il; ++i){
                    var _values;
                    // If the type is the same we only need to check if the color is in the correct format
                    if (values[i + 1] === other[i + 1]) {
                        if (values[i + 1] === Color && other[i + 7] !== values[i + 7]) {
                            var _this_values;
                            var space = other[i + 7];
                            var color = new Color(this.values.splice(i + 3, 5))[space]().toArray();
                            (_this_values = this.values).splice.apply(_this_values, [
                                i + 3,
                                0
                            ].concat(_to_consumable_array(color)));
                        }
                        i += values[i + 2] + 2;
                        continue;
                    }
                    if (!other[i + 1]) {
                        return this;
                    }
                    // The types differ, so we overwrite the new type with the old one
                    // And initialize it with the types default (e.g. black for color or 0 for number)
                    var defaultObject = new other[i + 1]().toArray();
                    // Than we fix the values array
                    var toDelete = values[i + 2] + 3;
                    (_values = values).splice.apply(_values, [
                        i,
                        toDelete,
                        other[i],
                        other[i + 1],
                        other[i + 2]
                    ].concat(_to_consumable_array(defaultObject)));
                    i += values[i + 2] + 2;
                }
                return this;
            }
        },
        {
            key: "init",
            value: function init(objOrArr) {
                this.values = [];
                if (Array.isArray(objOrArr)) {
                    this.values = objOrArr.slice();
                    return;
                }
                objOrArr = objOrArr || {};
                var entries = [];
                for(var i in objOrArr){
                    var Type = getClassForType(objOrArr[i]);
                    var val = new Type(objOrArr[i]).toArray();
                    entries.push([
                        i,
                        Type,
                        val.length
                    ].concat(_to_consumable_array(val)));
                }
                entries.sort(sortByKey);
                this.values = entries.reduce(function(last, curr) {
                    return last.concat(curr);
                }, []);
                return this;
            }
        },
        {
            key: "toArray",
            value: function toArray() {
                return this.values;
            }
        },
        {
            key: "valueOf",
            value: function valueOf() {
                var obj = {};
                var arr = this.values;
                // for (var i = 0, len = arr.length; i < len; i += 2) {
                while(arr.length){
                    var key = arr.shift();
                    var Type = arr.shift();
                    var num = arr.shift();
                    var values = arr.splice(0, num);
                    obj[key] = new Type(values) // .valueOf()
                    ;
                }
                return obj;
            }
        }
    ]);
    return ObjectBag;
}();
var morphableTypes = [
    NonMorphable,
    TransformBag,
    ObjectBag
];
export function registerMorphableType() {
    var type = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    var _morphableTypes;
    (_morphableTypes = morphableTypes).push.apply(_morphableTypes, _to_consumable_array([].concat(type)));
}
export function makeMorphable() {
    extend(morphableTypes, {
        to: function to(val) {
            return new Morphable().type(this.constructor).from(this.toArray()) // this.valueOf())
            .to(val);
        },
        fromArray: function fromArray(arr) {
            this.init(arr);
            return this;
        },
        toConsumable: function toConsumable() {
            return this.toArray();
        },
        morph: function morph(from, to, pos, stepper, context) {
            var mapper = function mapper(i, index) {
                return stepper.step(i, to[index], pos, context[index], context);
            };
            return this.fromArray(from.map(mapper));
        }
    });
}
